import { useCallback, useEffect, useState } from "react";
import Loading from "../../../components/utils/Loading";
import { isMoreThanFiveMinutesAgo } from "../../../components/formatted/FormattedDateAndTime";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import axios from "axios";
import Cookies from "js-cookie";
import { formattedColorMaterial } from "../../../components/formatted/FormattedText";
import {
  getHistoryCycleContainer,
  getHistoryFillingSpeed,
} from "../../../services/container";
import { useTranslation } from "react-i18next";
import ViewActivity from "../../../components/ViewActivity";

const ContainerViewActivity = ({ data, updateData }) => {
  const { t, i18n } = useTranslation();
  const API = process.env.REACT_APP_API_BACKEND;
  const token = Cookies.get("userToken");
  const { id } = useParams();
  const { _time, container } = JSON.parse(
    sessionStorage.getItem("containerDetails"),
  );
  const [historyCurrent, setHistoryCurrent] = useState([]);
  const [dataSortedByAnomalies, setDataSortedByAnomalies] = useState([]);
  const [historyId, setHistoryId] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [lastPackmatEfficiency, setLastPackmatEfficiency] = useState([]);
  const [numberOfStars, setNumberOfStars] = useState(0);
  const [numberOfPackmat, setNumberOfPackmat] = useState(0);
  const [dataNumberOfAnomaly, setDataNumberOfAnomaly] = useState([]);
  const [labelMaterialSeparate, setLabelMaterialSeparate] = useState([]);
  const [colorMaterial, setColorMaterial] = useState([]);
  const [totalAnomaly, setTotalAnomaly] = useState(0);
  const [anomalyDelivery, setAnomalyDelivery] = useState({});
  const [totalVolumeSortingError, setTotalVolumeSortingError] = useState(0);
  const [totalWasteVolume, setTotalWasteVolume] = useState(0);
  const [totalMassSortingError, setTotalMassSortingError] = useState(0);
  const [numberOfObjects, setNumberOfObjects] = useState(0);
  const [objectDelivery, setObjectDelivery] = useState({});
  const [colorObject, setColorObject] = useState([]);
  const [labelObjectSeparate, setLabelObjectSeparate] = useState([]);
  const [dataNumberOfObject, setDataNumberOfObject] = useState([]);
  const [durationFullFillingMs, setDurationFullFillingMs] = useState(0);
  const [reliablePrediction, setReliablePrediction] = useState(false);
  const [fromDate, setFromDate] = useState(new Date());

  const handleAnomalyList = (typeAnomaly) => {
    if (typeAnomaly) {
      const newAnomalyList = Object.keys(typeAnomaly).map((type, index) => ({
        name: `${t(type)}${type === "sorting_errors" ? ` (${t("sum of the sorting errors chart salues")})` : ""}`,
        value: type,
        nameAndCount: `${t(type)} (${typeAnomaly[type]})`,
        color: formattedColorMaterial(type),
        count: typeAnomaly[type],
      }));
      return newAnomalyList;
    }
  };

  const findHistoryId = (targetTime) => {
    const index = historyCurrent.findIndex((item) => item._time === targetTime);
    setHistoryId(index);
  };

  const fetchData = useCallback(
    () => {
      axios
        .all([
          getHistoryCycleContainer(
            {
              currentCycle: true,
              getLevelLastRotation: true,
            },
            id,
          ),
          getHistoryFillingSpeed(id),
        ])
        .then(
          axios.spread((responseHistoryCurrent, responseSpeedFilling) => {
            if (
              responseHistoryCurrent.status === 200 ||
              responseSpeedFilling.status === 200
            ) {
              setHistoryCurrent(responseHistoryCurrent.data.historyCycle);
              const filteredAndSortedData =
                responseHistoryCurrent.data.historyCycle
                  .filter((item) => item.anomalies > 0)
                  .sort((a, b) => b.anomalies - a.anomalies)
                  .slice(0, 8)
                  .sort((a, b) => new Date(b._time) - new Date(a._time));
              setDataSortedByAnomalies(filteredAndSortedData);
              setNumberOfStars(responseHistoryCurrent.data.numberOfStars);
              setTotalVolumeSortingError(
                responseHistoryCurrent.data.totalVolumeSortingError,
              );
              setTotalWasteVolume(responseHistoryCurrent.data.totalWasteVolume);
              setTotalMassSortingError(
                responseHistoryCurrent.data.totalMassSortingError,
              );
              setNumberOfPackmat(responseHistoryCurrent.data.numberOfPackmat);
              setLastPackmatEfficiency(
                responseHistoryCurrent.data.lastPackmatEfficiency[0],
              );
              setAnomalyDelivery(responseHistoryCurrent.data.anomalyDelivery);

              setNumberOfObjects(responseHistoryCurrent.data.numberOfObjects);
              setObjectDelivery(responseHistoryCurrent.data.objectDelivery);

              setFromDate(new Date(responseSpeedFilling.data.fromDate));
              setDurationFullFillingMs(
                responseSpeedFilling.data?.durationFullFillingMs[0]?.duration,
              );
              setReliablePrediction(
                responseSpeedFilling.data?.reliablePrediction[0],
              );

              const newData = {
                ...container,
                durationFullFillingMs:
                  responseSpeedFilling.data?.durationFullFillingMs,
                fromDate: responseSpeedFilling.data.fromDate,
                reliablePrediction:
                  responseSpeedFilling.data?.reliablePrediction,
                historyCurrent: responseHistoryCurrent.data.historyCycle,
                numberOfStars: responseHistoryCurrent.data.numberOfStars,
                numberOfAnomaly: responseHistoryCurrent.data.numberOfAnomaly,
                anomalyDelivery: responseHistoryCurrent.data.anomalyDelivery,
                numberOfPackmat: responseHistoryCurrent.data.numberOfPackmat,
                meanFillingLevelByOpenedDay:
                  responseSpeedFilling.data.fillingPerOpenedWeekday[0],
                meanFillingLevelByOpenedHour:
                  responseSpeedFilling.data.fillingPerOpenedHour[0],
                meanFillingLevelByDay:
                  responseSpeedFilling.data.fillingPerWeekday[0],
                levelLastRotation:
                  responseHistoryCurrent.data.levelLastRotation[0],
                dateLastRotation:
                  responseHistoryCurrent.data.historyCycle[
                    responseHistoryCurrent.data.historyCycle.length - 1
                  ],
                lastRotation: responseHistoryCurrent.data.lastRotation[0],
                lastPackmatEfficiency:
                  responseHistoryCurrent.data.lastPackmatEfficiency[0],
                numberOfObjects: responseHistoryCurrent.data.numberOfObjects,
                objectDelivery: responseHistoryCurrent.data.objectDelivery,
              };

              updateData(newData);
            }
          }),
        );
    },
    // eslint-disable-next-line
    [id, API, token],
  );

  useEffect(() => {
    const doAllVariablesExist = checkUndefined(
      data?.fromDate,
      data?.historyCurrent,
      data?.dateLastRotation,
      data?.numberOfStars,
    );
    if (isMoreThanFiveMinutesAgo(_time) || !doAllVariablesExist) {
      fetchData();
    } else {
      if (data?.historyCurrent) {
        setHistoryCurrent(data?.historyCurrent);
        const filteredAndSortedData = data?.historyCurrent
          .filter((item) => item.anomalies > 0)
          .sort((a, b) => b.anomalies - a.anomalies)
          .slice(0, 8)
          .sort((a, b) => new Date(b._time) - new Date(a._time));
        setDataSortedByAnomalies(filteredAndSortedData);
        setNumberOfStars(data?.numberOfStars);
        setTotalVolumeSortingError(data?.totalVolumeSortingError);
        setTotalWasteVolume(data?.totalWasteVolume);
        setTotalMassSortingError(data?.totalMassSortingError);
        setNumberOfPackmat(data?.numberOfPackmat);
        setLastPackmatEfficiency(data?.lastPackmatEfficiency);
        setAnomalyDelivery(data?.anomalyDelivery);
        setNumberOfObjects(data?.numberOfObjects);
        setObjectDelivery(data?.objectDelivery);
        setFromDate(new Date(data.fromDate));
        setDurationFullFillingMs(data?.durationFullFillingMs[0]?.duration);
        setReliablePrediction(data?.reliablePrediction[0]);
      }
    }
  }, [_time, data, fetchData]);

  const fetchTypeAnomaly = useCallback(
    () => {
      if (historyCurrent.length === 0) return;

      const anomalyList = handleAnomalyList(anomalyDelivery);

      const mergedMaterials = anomalyList.flat().reduce((merged, material) => {
        merged[material.name] = {
          ...(merged[material.name] || { ...material }),
          count: (merged[material.name]?.count || 0) + material.count,
        };
        return merged;
      }, {});

      const mergedArray = Object.values(mergedMaterials);
      const anomalyCount = mergedArray.map((anomaly) => anomaly.count);
      const anomalyNames = mergedArray.map((anomaly) => anomaly.name);
      const anomalyColors = mergedArray.map((anomaly) => anomaly.color);
      const total = anomalyCount.reduce((sum, count) => sum + count, 0);

      setDataNumberOfAnomaly(anomalyCount);
      setLabelMaterialSeparate(anomalyNames);
      setColorMaterial(anomalyColors);
      setTotalAnomaly(total);
      setIsLoading(false);
    },
    // eslint-disable-next-line
    [historyCurrent, anomalyDelivery, i18n.language],
  );

  const fetchObjectType = useCallback(
    () => {
      if (historyCurrent.length === 0) return;

      const objectList = handleAnomalyList(objectDelivery);

      const mergedMaterials = objectList.flat().reduce((merged, material) => {
        merged[material.name] = {
          ...(merged[material.name] || { ...material }),
          count: (merged[material.name]?.count || 0) + material.count,
        };
        return merged;
      }, {});

      const mergedArray = Object.values(mergedMaterials);
      const objectCount = mergedArray.map((material) => material.count);
      const objectNames = mergedArray.map((material) => material.name);
      const objectColors = mergedArray.map((material) => material.color);

      setColorObject(objectColors);
      setLabelObjectSeparate(objectNames);
      setDataNumberOfObject(objectCount);
      setIsLoading(false);
    },
    // eslint-disable-next-line
    [historyCurrent, objectDelivery, i18n.language],
  );

  useEffect(() => {
    fetchTypeAnomaly();
    fetchObjectType();
  }, [fetchTypeAnomaly, fetchObjectType]);

  // if one or more variables is set as undefined return false else return true
  function checkUndefined(...variables) {
    return variables.every((v) => v !== undefined);
  }

  return isLoading ? (
    <Loading color="#efefeffb" />
  ) : historyCurrent.length !== 0 ? (
    <ViewActivity
      dataSortedByAnomalies={dataSortedByAnomalies}
      historyId={historyId}
      lastPackmatEfficiency={lastPackmatEfficiency}
      numberOfStars={numberOfStars}
      numberOfPackmat={numberOfPackmat}
      totalVolumeSortingError={totalVolumeSortingError}
      totalWasteVolume={totalWasteVolume}
      totalMassSortingError={totalMassSortingError}
      colorObject={[colorObject]}
      labelObjectSeparate={[labelObjectSeparate]}
      dataNumberOfObject={[dataNumberOfObject]}
      numberOfObjects={[numberOfObjects]}
      dataAnomalyDelivery={[dataNumberOfAnomaly]}
      labelsAnomalyDelivery={[labelMaterialSeparate]}
      colorAnomalyDelivery={[colorMaterial]}
      historyCycle={historyCurrent}
      data={data}
      numberOfAnomaly={[totalAnomaly]}
      superContainerDataRow={[]}
      findHistoryId={findHistoryId}
      setHistoryId={setHistoryId}
      API={API}
      showMaterialDistributionCharts={true}
      durationFullFillingMs={durationFullFillingMs}
      reliablePrediction={reliablePrediction}
      fromDate={fromDate}
      monitoring={true}
    />
  ) : (
    <div className="no-data">
      {t("No data available to display the container's activity")}.
    </div>
  );
};

export default ContainerViewActivity;
